import type { ReactNode } from "react";

/**
 * Variant is kept as a prop for backwards compatibility but is ignored.
 * Accent colors come from the nearest [data-section] ancestor via the
 * --accent / --accent-glow CSS variables.
 */
export function PageHeader({
  icon,
  title,
  variant: _variant,
}: {
  icon: ReactNode;
  title: string;
  variant?: "cyan" | "purple";
}) {
  void _variant;
  return (
    <div style={{ marginBottom: "2rem" }}>
      <div style={{ display: "flex", alignItems: "center", gap: "0.6rem" }}>
        <span className="page-header-icon">{icon}</span>
        <h1 className="page-title">{title}</h1>
      </div>
      <div className="page-title-bar" style={{ marginBottom: 0 }} />
    </div>
  );
}
